/**
 * WaveformLogo — a freehand-style tilted cursive "M"
 * Organic flowing curves, slightly tilted like hand-drawn.
 */
export const WaveformLogo = ({ size = 32, className = "" }) => {
  const s = size;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ transform: "rotate(-8deg)" }}
    >
      <path
        d="M10 48 C10 48, 12 16, 16 14 C20 12, 22 38, 26 40 C30 42, 30 14, 34 12 C38 10, 38 40, 42 42 C46 44, 46 16, 50 14 C54 12, 56 48, 56 48"
        stroke="currentColor"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export const WaveformLogoSmall = WaveformLogo;
